export default (classes) => classes.filter(Boolean).join(' ')


// WEBPACK FOOTER //
// ./src/components/classes.js